import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Reports are read-only aggregations; all four endpoints take a date and time window plus an optional branch.
const base = (restaurantId) => `${API_URL}/users/restaurant/${restaurantId}/reports`;

function queryString({ dateFrom, dateTo, timeFrom, timeTo, locationId } = {}) {
  const p = new URLSearchParams();
  if (dateFrom) p.append('date_from', dateFrom);
  if (dateTo) p.append('date_to', dateTo);
  if (timeFrom) p.append('time_from', timeFrom);
  if (timeTo) p.append('time_to', timeTo);
  if (locationId) p.append('location_id', locationId);
  const s = p.toString();
  return s ? `?${s}` : '';
}

async function fetchReport(url) {
  try {
    const res = await axios.get(url);
    return res.data?.success ? res.data.data : null;
  } catch (error) {
    console.error('reportingService: error fetching', url, error);
    return null;
  }
}

export const getSalesSummary = (restaurantId, filters) =>
  fetchReport(`${base(restaurantId)}/sales-summary/${queryString(filters)}`);

export const getMenuPerformance = (restaurantId, filters) =>
  fetchReport(`${base(restaurantId)}/menu-performance/${queryString(filters)}`);

export const getFoodCost = (restaurantId, filters) =>
  fetchReport(`${base(restaurantId)}/food-cost/${queryString(filters)}`);

export const getServiceConsistency = (restaurantId, filters) =>
  fetchReport(`${base(restaurantId)}/service-consistency/${queryString(filters)}`);
